var TEMPLATE_URL = require('./billing.status.html');

angular.module('ikeweb.user').directive('billingStatus', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'BillingStatusController',
            controllerAs: 'ctrl'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/status/billing.status.directive.js
// module id = 156
// module chunks = 0